// src/slices/branchUserSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Async thunks for BranchUser CRUD operations
export const fetchBranchUsers = createAsyncThunk('branchUsers/fetchBranchUsers', async () => {
  const company_id = localStorage.getItem('companyID');
  const response = await axios.get(`${API_URL}/branchUsers/${company_id}`);
  return response.data;
});
export const fetchTaskUsersBranch = createAsyncThunk('branchUsers/fetchTaskUsersBranch', async () => {
  const company_id = localStorage.getItem('companyID');
  const user_id = localStorage.getItem('user_id');
  const response = await axios.get(`${API_URL}/branchUsers/task/users/${company_id}?user_id=${user_id}`);
  return response.data;
});

export const createBranchUser = createAsyncThunk('branchUsers/createBranchUser', async (branchUserData) => {
  const response = await axios.post(`${API_URL}/branchUsers`, branchUserData);
  return response.data;
});

export const updateBranchUser = createAsyncThunk('branchUsers/updateBranchUser', async ({ id, branchUserData }) => {
  const response = await axios.put(`${API_URL}/branchUsers/${id}`, branchUserData);
  return response.data;
});

export const deleteBranchUser = createAsyncThunk('branchUsers/deleteBranchUser', async (id) => {
  await axios.delete(`${API_URL}/branchUsers/${id}`);
  return id;
});

// Initial state
const initialState = {
  branchUsers: [],
  loading: false,
  error: null,
};

// BranchUser slice
const branchUserSlice = createSlice({
  name: 'branchUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch branch users
      .addCase(fetchBranchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.branchUsers = action.payload;
      })
      .addCase(fetchBranchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTaskUsersBranch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTaskUsersBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.branchUsers = action.payload;
      })
      .addCase(fetchTaskUsersBranch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create branch user
      .addCase(createBranchUser.fulfilled, (state, action) => {
        state.branchUsers.push(action.payload);
      })

      // Update branch user
      .addCase(updateBranchUser.fulfilled, (state, action) => {
        const index = state.branchUsers.findIndex((user) => user.id === action.payload.id);
        if (index !== -1) {
          state.branchUsers[index] = action.payload;
        }
      })

      // Delete branch user
      .addCase(deleteBranchUser.fulfilled, (state, action) => {
        state.branchUsers = state.branchUsers.filter((user) => user.id !== action.payload);
      });
  },
});

export default branchUserSlice.reducer;
